module.exports = __webpack_public_path__ + "img/bb-selected-icon.5860a02a.svg";